import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
    if (window.innerWidth <= 768) return;

    // Select all sections marked for stacked pin
    const pinnedSections = document.querySelectorAll(".stacked-pin, .is-style-stacked-pin");

    const sections = Array.from(pinnedSections).map(section => ({
        section,
        next: section.nextElementSibling
    }));

    sections.forEach(({section, next}) => {
        ScrollTrigger.create({
            trigger: section,
            pin: true,
            pinSpacing: false,
            start: "top top",
            endTrigger: next || section,
            end: next ? "top top" : () => "+=" + section.offsetHeight,
            invalidateOnRefresh: true
        });
    });

    window.addEventListener("load", () => ScrollTrigger.refresh());
});
